import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../../../src/client/layouts/touch/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_vlazyload_eb68cd60 from 'nuxt_plugin_vlazyload_eb68cd60' // Source: ./v-lazy-load.js (mode: 'all')
import nuxt_plugin_axios_6476243c from 'nuxt_plugin_axios_6476243c' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_setSource_792b08ae from 'nuxt_plugin_setSource_792b08ae' // Source: ../../../src/client/plugins/setSource (mode: 'all')
import nuxt_plugin_setLocale_911fbc30 from 'nuxt_plugin_setLocale_911fbc30' // Source: ../../../src/client/plugins/setLocale (mode: 'all')
import nuxt_plugin_i18n_926bd3dc from 'nuxt_plugin_i18n_926bd3dc' // Source: ../../../src/client/plugins/i18n (mode: 'all')
import nuxt_plugin_randomSecond_a7c0c1ea from 'nuxt_plugin_randomSecond_a7c0c1ea' // Source: ../../../src/client/plugins/randomSecond (mode: 'all')
import nuxt_plugin_constantMap_3805c0a4 from 'nuxt_plugin_constantMap_3805c0a4' // Source: ../../../src/client/plugins/constantMap (mode: 'all')
import nuxt_plugin_polyfill_793e4943 from 'nuxt_plugin_polyfill_793e4943' // Source: ../../../src/client/plugins/polyfill (mode: 'all')
import nuxt_plugin_vant_925e8cb6 from 'nuxt_plugin_vant_925e8cb6' // Source: ../../../src/client/plugins/vant (mode: 'all')
import nuxt_plugin_axios_d7481d5a from 'nuxt_plugin_axios_d7481d5a' // Source: ../../../src/client/plugins/axios.touch (mode: 'all')
import nuxt_plugin_filter_2aab3a6c from 'nuxt_plugin_filter_2aab3a6c' // Source: ../../../src/client/plugins/filter (mode: 'all')
import nuxt_plugin_appHub_2286d208 from 'nuxt_plugin_appHub_2286d208' // Source: ../../../src/client/plugins/appHub (mode: 'client')
import nuxt_plugin_setScene_a91d4984 from 'nuxt_plugin_setScene_a91d4984' // Source: ../../../src/client/plugins/setScene (mode: 'client')
import nuxt_plugin_attribution_bccf4bea from 'nuxt_plugin_attribution_bccf4bea' // Source: ../../../src/client/plugins/attribution (mode: 'client')
import nuxt_plugin_sensors_5894d8f6 from 'nuxt_plugin_sensors_5894d8f6' // Source: ../../../src/client/plugins/sensors (mode: 'client')
import nuxt_plugin_swiper_076f49ea from 'nuxt_plugin_swiper_076f49ea' // Source: ../../../src/client/plugins/swiper.js (mode: 'client')
import nuxt_plugin_webVitals_9b66b4a0 from 'nuxt_plugin_webVitals_9b66b4a0' // Source: ../../../src/client/plugins/webVitals.js (mode: 'client')
import nuxt_plugin_uaTrack_d7878728 from 'nuxt_plugin_uaTrack_d7878728' // Source: ../../../src/client/plugins/uaTrack.js (mode: 'client')
import nuxt_plugin_jsBridge_d4f977b4 from 'nuxt_plugin_jsBridge_d4f977b4' // Source: ../../../src/client/plugins/jsBridge (mode: 'client')
import nuxt_plugin_vitasutils_29cca403 from 'nuxt_plugin_vitasutils_29cca403' // Source: ../../../src/client/plugins/vitas-utils (mode: 'client')
import nuxt_plugin_vconsole_72441615 from 'nuxt_plugin_vconsole_72441615' // Source: ../../../src/client/plugins/vconsole (mode: 'client')
import nuxt_plugin_heic2any_22ca41c5 from 'nuxt_plugin_heic2any_22ca41c5' // Source: ../../../src/client/plugins/heic2any (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"lang":"en"},"title":"Think Academy","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0","id":"viewport"},{"http-equiv":"X-UA-Compatible","content":"IE=edge,chrome=1"},{"http-equiv":"Content-Security-Policy","content":"default-src https: http: data: wss: blob: 'self' 'unsafe-eval' 'unsafe-inline'; img-src data: https: http: 'unsafe-eval' 'unsafe-inline'; child-src https: http: blob:; script-src https: http: 'unsafe-eval' 'unsafe-inline';"},{"property":"og:image:alt","content":"Think Academy"},{"property":"og:image:width","content":"960"},{"property":"og:image:height","content":"960"},{"name":"facebook-domain-verification","content":"1akt43bah0cizuyqq5lyf235liolu1"}],"link":[{"rel":"dns-prefetch","href":"\u002F\u002Fdownload-pa-s3.thethinkacademy.com"},{"rel":"dns-prefetch","href":"\u002F\u002Fwww.google-analytics.com"},{"rel":"dns-prefetch","href":"\u002F\u002Fwww.googletagmanager.com"},{"rel":"dns-prefetch","href":"\u002F\u002Fapps.elfsight.com"},{"rel":"dns-prefetch","href":"\u002F\u002Fshence-datasink.thethinkacademy.com"},{"rel":"preconnect","href":"\u002F\u002Fgoogleads.g.doubleclick.net"},{"rel":"preconnect","href":"\u002F\u002Ftd.doubleclick.net"},{"rel":"preconnect","href":"\u002F\u002Fcdn.mouseflow.com"},{"rel":"preconnect","href":"\u002F\u002Fconnect.facebook.net"},{"rel":"preconnect","href":"\u002F\u002Fdownload-pa-s3.thethinkacademy.com"},{"rel":"preload","as":"font","href":"\u002F\u002Fdownload-pa-s3.thethinkacademy.com\u002Fstatic-pa\u002Fstatic\u002Ffonts\u002Fmontserrat\u002FMontserrat-Bold.woff","type":"font\u002Fwoff","crossorigin":"anonymous"}],"script":[{"async":true,"defer":true,"src":"https:\u002F\u002Faccounts.google.com\u002Fgsi\u002Fclient"},{"async":true,"defer":true,"src":"https:\u002F\u002Fconnect.facebook.net\u002Fen_US\u002Fsdk.js#xfbml=1&version=v20.0&appId=471070058610108","crossorigin":"anonymous"},{"async":true,"defer":true,"src":"https:\u002F\u002Fappleid.cdn-apple.com\u002Fappleauth\u002Fstatic\u002Fjsapi\u002Fappleid\u002F1\u002Fen_US\u002Fappleid.auth.js"},{"async":true,"defer":true,"src":"https:\u002F\u002Fassets.calendly.com\u002Fassets\u002Fexternal\u002Fwidget.js"},{"async":true,"defer":true,"src":"https:\u002F\u002Fwidget.trustpilot.com\u002Fbootstrap\u002Fv5\u002Ftp.widget.bootstrap.min.js"}],"__dangerouslyDisableSanitizers":["script"],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_vlazyload_eb68cd60 === 'function') {
    await nuxt_plugin_vlazyload_eb68cd60(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_6476243c === 'function') {
    await nuxt_plugin_axios_6476243c(app.context, inject)
  }

  if (typeof nuxt_plugin_setSource_792b08ae === 'function') {
    await nuxt_plugin_setSource_792b08ae(app.context, inject)
  }

  if (typeof nuxt_plugin_setLocale_911fbc30 === 'function') {
    await nuxt_plugin_setLocale_911fbc30(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_926bd3dc === 'function') {
    await nuxt_plugin_i18n_926bd3dc(app.context, inject)
  }

  if (typeof nuxt_plugin_randomSecond_a7c0c1ea === 'function') {
    await nuxt_plugin_randomSecond_a7c0c1ea(app.context, inject)
  }

  if (typeof nuxt_plugin_constantMap_3805c0a4 === 'function') {
    await nuxt_plugin_constantMap_3805c0a4(app.context, inject)
  }

  if (typeof nuxt_plugin_polyfill_793e4943 === 'function') {
    await nuxt_plugin_polyfill_793e4943(app.context, inject)
  }

  if (typeof nuxt_plugin_vant_925e8cb6 === 'function') {
    await nuxt_plugin_vant_925e8cb6(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_d7481d5a === 'function') {
    await nuxt_plugin_axios_d7481d5a(app.context, inject)
  }

  if (typeof nuxt_plugin_filter_2aab3a6c === 'function') {
    await nuxt_plugin_filter_2aab3a6c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_appHub_2286d208 === 'function') {
    await nuxt_plugin_appHub_2286d208(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_setScene_a91d4984 === 'function') {
    await nuxt_plugin_setScene_a91d4984(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_attribution_bccf4bea === 'function') {
    await nuxt_plugin_attribution_bccf4bea(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sensors_5894d8f6 === 'function') {
    await nuxt_plugin_sensors_5894d8f6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_swiper_076f49ea === 'function') {
    await nuxt_plugin_swiper_076f49ea(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_webVitals_9b66b4a0 === 'function') {
    await nuxt_plugin_webVitals_9b66b4a0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_uaTrack_d7878728 === 'function') {
    await nuxt_plugin_uaTrack_d7878728(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_jsBridge_d4f977b4 === 'function') {
    await nuxt_plugin_jsBridge_d4f977b4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vitasutils_29cca403 === 'function') {
    await nuxt_plugin_vitasutils_29cca403(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vconsole_72441615 === 'function') {
    await nuxt_plugin_vconsole_72441615(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_heic2any_22ca41c5 === 'function') {
    await nuxt_plugin_heic2any_22ca41c5(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
